/* Frensville storefront behaviour. No dependencies. */
(function () {
  'use strict';

  var routes = window.routes || {};
  var settings = window.fvSettings || { strings: {} };
  var $ = function (sel, root) { return (root || document).querySelector(sel); };
  var $$ = function (sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); };

  /* ---------- Toast ---------- */
  var toastTimer;
  function toast(message) {
    var el = $('[data-toast]');
    if (!el) return;
    el.textContent = message;
    el.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { el.hidden = true; }, 2600);
  }

  /* ---------- Drawers ---------- */
  var lastFocus = null;
  function openDrawer(drawer) {
    if (!drawer) return;
    lastFocus = document.activeElement;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('has-drawer');
    $$('[aria-controls="' + drawer.id + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
    var focusable = drawer.querySelector('.drawer__panel button, .drawer__panel a');
    if (focusable) setTimeout(function () { focusable.focus(); }, 50);
  }
  function closeDrawer(drawer) {
    if (!drawer || !drawer.classList.contains('is-open')) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    if (!$('.drawer.is-open')) document.body.classList.remove('has-drawer');
    $$('[aria-controls="' + drawer.id + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    if (lastFocus) lastFocus.focus();
  }

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-drawer-open]');
    if (opener) {
      e.preventDefault();
      openDrawer(document.getElementById(opener.getAttribute('data-drawer-open')));
      return;
    }
    var closer = e.target.closest('[data-drawer-close]');
    if (closer) {
      e.preventDefault();
      closeDrawer(closer.closest('[data-drawer]'));
      return;
    }
    var cartToggle = e.target.closest('[data-cart-toggle]');
    if (cartToggle && $('[data-cart-drawer]')) {
      e.preventDefault();
      openDrawer($('[data-cart-drawer]'));
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      $$('.drawer.is-open').forEach(closeDrawer);
      $$('details[data-close-outside][open]').forEach(function (d) { d.removeAttribute('open'); });
    }
  });

  /* Close dropdown <details> when clicking elsewhere */
  document.addEventListener('click', function (e) {
    $$('details[data-close-outside][open]').forEach(function (d) {
      if (!d.contains(e.target)) d.removeAttribute('open');
    });
  });

  /* ---------- Header: shadow on scroll + search panel ---------- */
  var header = $('[data-header]');
  if (header) {
    var onScroll = function () { header.classList.toggle('is-scrolled', window.scrollY > 8); };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-search-toggle]');
    if (!t) return;
    var panel = $('[data-search-panel]');
    if (!panel) return;
    panel.hidden = !panel.hidden;
    $$('[data-search-toggle][aria-controls]').forEach(function (b) { b.setAttribute('aria-expanded', String(!panel.hidden)); });
    if (!panel.hidden) { var input = panel.querySelector('input[type="search"]'); if (input) input.focus(); }
  });

  /* ---------- Scroll reveal + count-up (frens.vc) ----------
     Content below the first section fades up as it enters the viewport; grids
     reveal item by item. Skipped in the theme editor and for reduced motion,
     and the CSS only hides .reveal once this script has added it. */
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var designMode = window.Shopify && window.Shopify.designMode;
  if ('IntersectionObserver' in window && !reduceMotion && !designMode) {
    var GRIDS = '.product-grid, .pillars, .posts, .frens, .stats, .experience, .iwt, .collection-list, .article-grid';
    var revealTargets = [];
    $$('main > .shopify-section:not(:first-child) .page-width > *').forEach(function (el) {
      if (el.matches(GRIDS)) {
        Array.prototype.forEach.call(el.children, function (child, i) {
          child.style.transitionDelay = Math.min(i, 5) * 0.08 + 's';
          revealTargets.push(child);
        });
      } else {
        revealTargets.push(el);
      }
    });
    var revealObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        revealObserver.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    revealTargets.forEach(function (el) {
      el.classList.add('reveal');
      revealObserver.observe(el);
    });

    var countObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        countObserver.unobserve(entry.target);
        var el = entry.target;
        var match = el.textContent.trim().match(/^([\d,]+)(.*)$/);
        if (!match) return;
        var target = parseInt(match[1].replace(/,/g, ''), 10);
        var useCommas = match[1].indexOf(',') !== -1;
        var suffix = match[2];
        var start = null;
        var duration = 1400;
        function frame(ts) {
          if (start === null) start = ts;
          var p = Math.min(1, (ts - start) / duration);
          var eased = 1 - Math.pow(1 - p, 3);
          var value = Math.round(target * eased);
          el.textContent = (useCommas ? value.toLocaleString('en-US') : String(value)) + suffix;
          if (p < 1) requestAnimationFrame(frame);
        }
        requestAnimationFrame(frame);
      });
    }, { threshold: 0.5 });
    $$('[data-count-up]').forEach(function (el) { countObserver.observe(el); });
  }

  /* ---------- Announcement rotation ---------- */
  $$('[data-announcement]').forEach(function (bar) {
    var msgs = $$('.announcement__msg', bar);
    if (msgs.length < 2 || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var i = 0;
    setInterval(function () {
      msgs[i].classList.remove('is-active');
      i = (i + 1) % msgs.length;
      msgs[i].classList.add('is-active');
    }, 5000);
  });

  /* ---------- Cart ---------- */
  function cartSectionIds() {
    return $$('[data-cart-section]').map(function (el) { return el.getAttribute('data-section-id'); }).filter(Boolean);
  }

  function renderCartSections(sections) {
    if (!sections) return;
    Object.keys(sections).forEach(function (id) {
      var html = sections[id];
      if (!html) return;
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = doc.querySelector('[data-cart-section][data-section-id="' + id + '"]');
      var current = $('[data-cart-section][data-section-id="' + id + '"]');
      if (fresh && current) {
        current.innerHTML = fresh.innerHTML;
        var count = fresh.getAttribute('data-cart-count-value');
        if (count !== null) current.setAttribute('data-cart-count-value', count);
      }
    });
  }

  function updateCount(count) {
    $$('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.hidden = Number(count) === 0;
    });
  }

  function refreshCountFromCart(cart) {
    if (cart && typeof cart.item_count === 'number') {
      updateCount(cart.item_count);
      return;
    }
    fetch(routes.cart + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { updateCount(c.item_count); })
      .catch(function () {});
  }

  function changeLine(line, quantity) {
    var sections = cartSectionIds();
    $$('[data-cart-section]').forEach(function (el) { el.style.opacity = '0.6'; });
    return fetch(routes.cart_change + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: Number(line), quantity: Math.max(0, Number(quantity)), sections: sections.join(','), sections_url: window.location.pathname })
    })
      .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.data.description || res.data.message || settings.strings.error);
        renderCartSections(res.data.sections);
        refreshCountFromCart(res.data);
      })
      .catch(function (err) { toast(err.message || settings.strings.error); })
      .finally(function () { $$('[data-cart-section]').forEach(function (el) { el.style.opacity = ''; }); });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-line-change]');
    if (!btn) return;
    e.preventDefault();
    changeLine(btn.getAttribute('data-line-change'), btn.getAttribute('data-qty-to'));
  });

  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-line-input]');
    if (!input) return;
    changeLine(input.getAttribute('data-line-input'), input.value);
  });

  /* Add to cart (drawer mode only; page mode posts the form normally) */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-product-form]');
    if (!form || settings.cartType !== 'drawer' || !$('[data-cart-drawer]')) return;
    e.preventDefault();

    var button = form.querySelector('[data-add-button]') || form.querySelector('[type="submit"]');
    var errorBox = form.querySelector('[data-form-error]');
    if (errorBox) errorBox.hidden = true;
    if (button) { button.classList.add('is-loading'); button.setAttribute('aria-disabled', 'true'); }

    var body = new FormData(form);
    // Radios that live outside the form (form="…") are included by FormData automatically.
    body.append('sections', cartSectionIds().join(','));
    body.append('sections_url', window.location.pathname);

    fetch(routes.cart_add + '.js', {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' },
      body: body
    })
      .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.data.description || res.data.message || settings.strings.error);
        renderCartSections(res.data.sections);
        var drawerPanel = $('[data-cart-drawer] [data-cart-section]');
        if (drawerPanel) updateCount(drawerPanel.getAttribute('data-cart-count-value'));
        else refreshCountFromCart();
        openDrawer($('[data-cart-drawer]'));
      })
      .catch(function (err) {
        if (errorBox) { errorBox.textContent = err.message; errorBox.hidden = false; }
        else toast(err.message);
      })
      .finally(function () {
        if (button) { button.classList.remove('is-loading'); button.removeAttribute('aria-disabled'); }
      });
  });

  /* ---------- Quantity steppers (product page) ---------- */
  document.addEventListener('click', function (e) {
    var minus = e.target.closest('[data-qty-minus]');
    var plus = e.target.closest('[data-qty-plus]');
    if (!minus && !plus) return;
    var input = (minus || plus).closest('[data-qty]').querySelector('input');
    var v = parseInt(input.value, 10) || 1;
    input.value = Math.max(1, v + (plus ? 1 : -1));
  });

  /* ---------- Product: variants + gallery ---------- */
  function showMedia(section, mediaId) {
    if (!mediaId) return;
    var target = section.querySelector('.media-item[data-media-id="' + mediaId + '"]');
    if (!target) return;
    $$('.media-item', section).forEach(function (m) { m.classList.toggle('is-active', m === target); });
    $$('[data-thumb]', section).forEach(function (t) {
      if (t.getAttribute('data-thumb') === String(mediaId)) t.setAttribute('aria-current', 'true');
      else t.removeAttribute('aria-current');
    });
  }

  document.addEventListener('click', function (e) {
    var thumb = e.target.closest('[data-thumb]');
    if (!thumb) return;
    showMedia(thumb.closest('[data-product-section]'), thumb.getAttribute('data-thumb'));
  });

  /* Hold the sticky gallery still while rows below it change height.
     Once the gallery has scrolled to the bottom of its column, sticky pins it
     there — so an accordion or tab panel growing that column drags it down.
     Before such a click, freeze the gallery where it is; hand it back to sticky
     when scrolling brings it up to its sticky line again, which is seamless. */
  function holdGallery(section) {
    var gallery = section && section.querySelector('.product__gallery');
    if (!gallery || gallery.classList.contains('is-held')) return;
    var style = getComputedStyle(gallery);
    if (style.position !== 'sticky') return;
    var stickyTop = parseFloat(style.top) || 0;
    var rect = gallery.getBoundingClientRect();
    // Still riding its sticky line: growth below cannot move it.
    if (rect.top >= stickyTop - 1) return;
    var columnTop = gallery.parentElement.getBoundingClientRect().top;
    gallery.style.setProperty('--held-top', rect.top - columnTop + 'px');
    gallery.dataset.stickyTop = stickyTop;
    gallery.classList.add('is-held');
  }

  // After a collapse the column may end above the held gallery; pull it up
  // only as far as needed to stay inside, as sticky itself would.
  function clampHeldGallery(gallery) {
    var max = gallery.parentElement.getBoundingClientRect().height - gallery.offsetHeight;
    var current = parseFloat(gallery.style.getPropertyValue('--held-top')) || 0;
    if (current > max) gallery.style.setProperty('--held-top', Math.max(0, max) + 'px');
  }

  function releaseGallery(gallery) {
    gallery.classList.remove('is-held');
    gallery.style.removeProperty('--held-top');
  }

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('.product__info summary, .product__info [role="tab"]');
    if (!trigger) return;
    var section = trigger.closest('[data-product-section]');
    holdGallery(section);
    requestAnimationFrame(function () {
      var held = section && section.querySelector('.product__gallery.is-held');
      if (held) clampHeldGallery(held);
    });
  }, true); // capture: freeze before the tab handler swaps panels

  window.addEventListener('scroll', function () {
    $$('.product__gallery.is-held').forEach(function (gallery) {
      if (gallery.getBoundingClientRect().top >= Number(gallery.dataset.stickyTop) - 1) releaseGallery(gallery);
    });
  }, { passive: true });

  window.addEventListener('resize', function () {
    $$('.product__gallery.is-held').forEach(releaseGallery);
  });

  document.addEventListener('change', function (e) {
    var radio = e.target.closest('[data-variant-radio]');
    if (!radio) return;
    var section = radio.closest('[data-product-section]');
    if (!section) return;

    var priceEl = section.querySelector('[data-price]');
    var compareEl = section.querySelector('[data-compare]');
    var wrap = section.querySelector('[data-price-wrap]');
    if (priceEl) priceEl.innerHTML = radio.getAttribute('data-price');
    var compare = radio.getAttribute('data-compare');
    if (compareEl) { compareEl.innerHTML = compare; compareEl.hidden = !compare; }
    if (wrap) wrap.classList.toggle('price--sale', !!compare);

    var available = radio.getAttribute('data-available') === 'true';
    var button = section.querySelector('[data-add-button]');
    var label = section.querySelector('[data-add-label]');
    if (button) button.disabled = !available;
    if (label) label.textContent = available ? settings.strings.addToCart : settings.strings.soldOut;

    showMedia(section, radio.getAttribute('data-media-id'));

    var url = section.getAttribute('data-url');
    if (url && window.history.replaceState) {
      window.history.replaceState({}, '', url + '?variant=' + radio.value);
    }
  });

  /* ---------- Tabs (Read / Parent Guide / Activity) ---------- */
  document.addEventListener('click', function (e) {
    var tab = e.target.closest('[role="tab"]');
    if (!tab) return;
    var group = tab.closest('[data-tabs]');
    if (!group) return;
    $$('[role="tab"]', group).forEach(function (t) {
      var selected = t === tab;
      t.setAttribute('aria-selected', String(selected));
      var panel = document.getElementById(t.getAttribute('aria-controls'));
      if (panel) panel.hidden = !selected;
    });
  });

  /* ---------- Recommendations ---------- */
  $$('[data-recommendations]').forEach(function (el) {
    var url = el.getAttribute('data-url');
    if (!url || el.children.length) return;
    fetch(url)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-recommendations]');
        if (fresh && fresh.innerHTML.trim()) el.innerHTML = fresh.innerHTML;
      })
      .catch(function () {});
  });

  /* ---------- Collection filters: auto-submit ---------- */
  document.addEventListener('change', function (e) {
    var el = e.target.closest('[data-auto-submit]');
    if (!el) return;
    var form = el.closest('form');
    if (form) form.submit();
  });

  /* ---------- Account helpers ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-toggle-target]');
    if (t) {
      var target = document.getElementById(t.getAttribute('data-toggle-target'));
      if (target) target.hidden = !target.hidden;
      return;
    }
    var r = e.target.closest('[data-recover-toggle]');
    if (r) {
      e.preventDefault();
      var login = $('[data-login-view]');
      var recover = $('[data-recover-view]');
      if (login && recover) { login.hidden = !login.hidden; recover.hidden = !recover.hidden; }
    }
  });

  if (window.location.hash === '#recover' || $('[data-recover-success]')) {
    var lv = $('[data-login-view]');
    var rv = $('[data-recover-view]');
    if (lv && rv) { lv.hidden = true; rv.hidden = false; }
  }

  document.addEventListener('submit', function (e) {
    var f = e.target.closest('form[data-confirm]');
    if (f && !window.confirm(f.getAttribute('data-confirm'))) e.preventDefault();
  });

  /* Country → province selects on the address form */
  $$('[data-country-select]').forEach(function (select) {
    var provinceSelect = document.getElementById(select.getAttribute('data-province-target'));
    var provinceWrap = provinceSelect ? document.getElementById(provinceSelect.id + '_wrap') : null;
    if (select.getAttribute('data-default')) select.value = select.getAttribute('data-default');

    function syncProvinces() {
      if (!provinceSelect) return;
      var option = select.options[select.selectedIndex];
      var raw = option ? option.getAttribute('data-provinces') : null;
      var provinces = raw ? JSON.parse(raw) : [];
      provinceSelect.innerHTML = '';
      provinces.forEach(function (p) {
        var o = document.createElement('option');
        o.value = p[0];
        o.textContent = p[1];
        provinceSelect.appendChild(o);
      });
      if (provinceWrap) provinceWrap.hidden = provinces.length === 0;
      var def = provinceSelect.getAttribute('data-default');
      if (def) provinceSelect.value = def;
    }
    select.addEventListener('change', function () { provinceSelect && provinceSelect.removeAttribute('data-default'); syncProvinces(); });
    syncProvinces();
  });
})();
